import { useContext } from "react";
import { useAddresses } from "../../../Addresses/useAddresses";
import { usePlansQuery } from "../../../SWR/Plans/usePlansQuery";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { onModalClose } from "../deliveryModalUtils/helpers";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
/**
 *
 * @param orderId
 * @param refetchOrders
 * @param updateFunction
 * @returns
 */
export const useUpdateOrderDeliveryModal = (props) => {
    var _a, _b, _c;
    const { currentOrderId, currentOrderNumber, currentOrderStatus, currentOrderInfo, flowSku, initTabProps, programId, refetchOrders, setShowModal, showModal, subscriptionLinkId, updateFunction, formId, } = props;
    const { setNewAddressData, setPaymentDetails } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { setBalance } = useContext(PaymentFormContext);
    const addressesData = useAddresses(currentOrderId, programId, undefined);
    const { addressState: { loading }, } = addressesData;
    // Derive usesLocation/usesZipCodes from plans data instead of address state
    const { data: plansResponse } = usePlansQuery();
    const plan = plansResponse === null || plansResponse === void 0 ? void 0 : plansResponse.data.find((p) => p.programId === programId);
    const usesLocation = (_a = plan === null || plan === void 0 ? void 0 : plan.usesLocation) !== null && _a !== void 0 ? _a : false;
    const usesZipCodes = (_b = plan === null || plan === void 0 ? void 0 : plan.usesZipCodes) !== null && _b !== void 0 ? _b : false;
    const onClose = onModalClose(setNewAddressData, setBalance, setShowModal, setPaymentDetails);
    const componentProps = {
        addressesData,
        flowSku,
        initTabProps,
        loading,
        onClose,
        orderId: currentOrderId,
        orderInfo: currentOrderInfo,
        orderNumber: currentOrderNumber,
        orderStatus: currentOrderStatus,
        programId,
        refetchOrders,
        setBalance,
        setNewAddressData,
        setShowModal,
        showAddresses: usesLocation || usesZipCodes || ((_c = initTabProps === null || initTabProps === void 0 ? void 0 : initTabProps.isCheckout) !== null && _c !== void 0 ? _c : false),
        showModal,
        updateFunction,
        formId,
    };
    return componentProps;
};
